import { appsignal } from 'helpers/analytics'

const initialState = {}

// simple centralized error handling.
// Every action that triggers error will end here
const errorReducer = (state = initialState, { type, payload = {} }) => {
  if (payload?.error) {
    if (appsignal?.sendError) {
      appsignal.sendError(payload.error, span => {
        span.setAction(payload.error)
        span.setNamespace(type)
        span.setTags({ tag1: 'saga_error' })
      })
    }

    return {
      [type]: payload.error
    }
  }

  if (type === 'ROUTE_CHANGE') {
    return {
      ...initialState
    }
  }

  return state
}

export default errorReducer
